import React from 'react';
import {ShowableProductCard} from "../../Ddd/Aggregates/ShowableProductCard";
import {observer} from "mobx-react";
import {CharacterListValueV1} from "../CharacterListValueV1/CharacterListValueV1";

type CharacterListV3Props = {
    productCard: ShowableProductCard
}

const CharacterListV3 = observer((props: CharacterListV3Props) => {
    return (
        <>
            {props.productCard.actualFields.map((v, k) => {
                return (
                    <div className="character-list-v3__row" key={`cv-tr${k}`}>
                        <div className="character-list-v3__title">
                            {v.title}
                        </div>
                        <div className="character-list-v3__dash"></div>
                        <CharacterListValueV1 className="character-list-v3__value" value={v.value} unit={v.unit}/>
                    </div>
                )
            })}
        </>
    )
});

export {CharacterListV3}

